export default class User {
    setUser(props){
        this.id = props.id;
        this.first_name = props.first_name;
        this.last_name = props.last_name;
        this.email = props.email;
    }
}